import { useEffect, useState } from "react";
import { get } from "../utils/api";

interface PermissionLink {
  to: string;
  name: string;
  enabled: boolean;
}

interface MenuPermissions {
  title: string;
  links: PermissionLink[];
  enabled: boolean;

}

const useMenuPermissions = (): MenuPermissions[] => {
  const [menuSections, setMenuSections] = useState<MenuPermissions[]>([]);

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        // Fetch permissions for the current user's role
        const response = await get("admin_user_roles/details", { role_id: 1 }); // Replace 1 with dynamic role ID if needed
        console.log("permissions",response.data.permissions);
        const permissions: MenuPermissions[] = response.data.permissions;

        // Filter out sections and links that are not allowed
        const allowedSections = permissions
          .map((section) => ({
            ...section,
            links: section.links.filter((link) => link.enabled),
          }))
          .filter((section) => section.enabled); // Exclude sections with no allowed links

        setMenuSections(allowedSections);
      } catch (error) {
        console.error("Failed to load permissions:", error);
      }
    };

    loadPermissions();
  }, []);

  return menuSections;
};

export default useMenuPermissions;
